var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      class: _vm.input.extraClass,
      style: _vm.input.style,
    },
    [
      _c(
        "div",
        { staticClass: "inner" },
        [
          _vm._l(
            _vm.getNestedValue(_vm.formValue, _vm.input.value),
            function (sectionValue, index) {
              return [
                _c(
                  "div",
                  { class: _vm.input.grid },
                  [
                    _vm._l(_vm.input.forms, function (sectionInput, index2) {
                      return [
                        _c("InputField", {
                          attrs: {
                            input: sectionInput,
                            formValue: sectionValue,
                          },
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            }
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }